import { type RootState } from '../rmsStore'

export default function getNOCDashboardReducer (state: RootState): NOCDashboardState {
  return state.nocDashboardReducer
}
